var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 25,
    viewBox: "0 0 43 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6328H42.7044",
    stroke: "url(#paint0_linear_2243_25239)",
    strokeWidth: 2.64749,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6328L43 12.6328",
    stroke: "url(#paint1_linear_2243_25239)",
    strokeWidth: 2.54402,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1758 1.81791C9.26473 4.79842 4.91218 9.64951 2.00113 12.63L12.1758 24.0781",
    stroke: "url(#paint2_linear_2243_25239)",
    strokeWidth: 2.54402,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2243_25239",
    x1: 2,
    y1: 13.6328,
    x2: 2.18278,
    y2: 11.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2243_25239",
    x1: 2,
    y1: 11.6328,
    x2: 2.18147,
    y2: 14.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2243_25239",
    x1: 2.00113,
    y1: 24.0781,
    x2: 10.9143,
    y2: 11.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/ArrowBack .a4ed0f440032026e2ef934f6ee52a3a2.svg";
export { ForwardRef as ReactComponent };